import React, { useEffect, useState ,useContext, useMemo, useRef } from 'react';
import axios from 'axios';
import { CONSTANT, STONE_SIZE_OPTIONS, STONE_SIZE_MARKS } from '../../utils/constants';
import { FingerSize } from './FilterOption/FingerSize';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import SpinnerComponent  from '../../utils/SpinnerComponent';
import { CommonFilter } from './FilterOption/CommonFilter';
import { GlobalContext } from '../../utils/GlobalContext';
import { AjaxDiamond } from '../../Modal/AjaxDiamond';
import { DropHint } from '../../Modal/DropHint';
import { SaveWishlist } from './Modal/SaveWishlist';
import SliderImages from './FilterOption/SliderImages';
import '../../../css/GenericBuilder/BuildRingMain.css';
import '../../../css/SingleRingBuilder/SingleRingBuilder.css';
import { formatNumber } from '../../utils/helpers';
import { HologramViewerContext } from '../../utils/HologramViewerContext';
import { handleMetalColorHologram, handleStoneColorHologram, removeInstalizeViewwer } from '../../utils/helpers';

const colorSuffixMap = {
    'Yellow Gold': '-YG',
    'Rose Gold':   '-RG',
    'White Gold':  '',
    'PLATINUM':    '',
    'SILVER':      '',
};

const isValidValue = (value) => {
    if (typeof value === 'number') return true;
    if (!value) return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'string' && value.trim() === '') return false;
    return true;
};

export const MainClass = ({ handlePagesChanges, initialRingCategory = 'Most-Popular', initialSelectedItem = null, initialMetalColor = 'White Gold' }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth); // State for screen width
    const [loadingContent, setLoadingContent] = useState(false);
    const [loadingContentCanvas, setLoadingContentCanvas] = useState(false);
    const { client_code, addToBasket, updatedSelectedItemDetails, accessToken, golbalClientDetails, layerparam, updateLayerParams} = useContext(GlobalContext);

    const [ringType, setRingType] = useState('14K');
    const [settingType, setSettingType] = useState('14K');
    const [ringColor, setRingColor] = useState(initialMetalColor);
    const [settingColor, setSettingColor] = useState(initialMetalColor);
    const [ringQuality, setRingQuality] = useState('GHSI');
    const [settingQuality, setSettingQuality] = useState('GHSI');
    const [colorCode, setColorCode] = useState('');
    const [ringCategory, setRingCategory] = useState(initialRingCategory);


    const [centerStoneShapeList, setCenterStoneShapeList] = useState([]);
    const [centerStoneShapeId, setCenterStoneShapeId] = useState([]);
    const [centerShapeLoading, setCenterShapeLoading] = useState(false);
    
    const [itemHeadList, setItemHeadList] = useState([]);
    const [headItemDetail, setHeadItemDetail] = useState('H001');
    const [headItemId, setHeadItemId] = useState([]);
    const [headLoading, setHeadLoading] = useState(false);
    const [headPrices,setHeadPrices] = useState(0);

    const [itemShangList, setItemShangList] = useState([]);
    const [shangItemDetail, setShangItemDetail] = useState('S001');
    const [shangItemId, setShangItemId] = useState([]);
    const [shangLoading, setShangLoading] = useState(false);
    const [categoryLoading, setCategoryLoading] = useState(false);
    const [ringCategoryList, setRingCategoryList] = useState([]);
    const [ringCategoryItem, setRingCategoryItem] = useState();

    const [shangPrices,setShangPrices] = useState(0);
    const _dp = layerparam['DiamondPageList'];

    const [centerStoneSize, setCenterStoneSize] = useState('1.00');
    const [imagesList, setImageList] = useState();
    const [currentImage, setCurrentImage] = useState();
    const [shahApiProduct, setShahApiProduct] = useState({});
    const [itemHeadDetails, setItemHeadDetails] = useState({});
    const [itemShangDetails, setItemShangDetails] = useState({});

    const [ glbFiles, setglbFiles ] = useState('');
    const { getHologram } = useContext(HologramViewerContext);

    const [fingerSize, setFingerSize] = useState('6.50');
    const [isInBasket, setIsInBasket] = useState(false);
    const [basketError, setBasketError] = useState(null);
    const [itemDetails, setitemDetails] = useState({});
    const [isModalDiamondOpen, setIsModalDiamondOpen] = useState(false);
    const [loadingItemPrices,setLoadingItemPricesItemPrices] = useState(false);
    const canvasRef = useRef(null);
    const skipFetchRef = useRef(false);
    const fetchDebounceRef = useRef(null);
    const [selectedDiamondDetails, setselectedDiamondDetails] = useState(() => {
        return layerparam?.['Diamond Details']?.diamond_details || null;
    });
    const [centerStoneWeight,setCenterStoneWeight] = useState(1);

    const [diamondPriceDetails,setDiamondPriceDetails] = useState(() => {
        const diamond_prices = layerparam?.['Diamond Details']?.diamond_prices;
        if (diamond_prices != null && diamond_prices !== '') {
            const parsed = typeof diamond_prices === 'string'
                ? parseFloat(diamond_prices.replace(/[$, ]/g, ''))
                : parseFloat(diamond_prices);
            return isNaN(parsed) ? 0 : parsed;
        }
        return 0;
    });
    
    const [centerStoneShape, setCenterStoneShape] = useState(()=>{
        return layerparam?.['Diamond Details']?.diamond_details?.shape || 'Round';
    });

    const [isReceDiamond,setIsReceDiamond] = useState();
    const [productInformation, setProductInformation] = useState();
    const [metalComponentColor, setMetalComponentColor] = useState();
// Memoized total price calculation
    const totalPrice = useMemo(() => {
        const basePrice = parseFloat(headPrices) + parseFloat(shangPrices);
        return diamondPriceDetails > 0 ? basePrice + parseFloat(diamondPriceDetails) : basePrice;
    }, [headPrices, shangPrices, diamondPriceDetails]);

    // Memoized basket item to prevent unnecessary recalculations
    const basketItemData = useMemo(() => ({
        itemDetails: itemDetails,
        "Metal Head Type": ringType,
        "Metal Shank Type": settingType,
        "Metal Head Color": ringColor,
        "Metal Shank Color": settingColor,
        "Diamond Quality-Head": ringQuality,
        "Diamond Quality-Shank": settingQuality,
        "Center Stone Size": centerStoneSize,
        "Finger Size": fingerSize,
        "Center Stone Shape": centerStoneShape,
        "Head + Shank Price": headPrices + shangPrices,
        price: headPrices + shangPrices,
    }), [itemDetails, ringType, settingType, ringColor, settingColor, ringQuality, settingQuality, centerStoneSize, fingerSize, centerStoneShape, headPrices, shangPrices]);

    const handleMetalType = async(value,Key) => {
        Key === 'Ring' ? setRingType(value) : setSettingType(value);
        if(value == "PLATINUM"){
            Key === 'Ring' ? setRingColor('PLATINUM') : setSettingColor('PLATINUM');

            const metal_color = CONSTANT.MetalColorShank[value];
            const colorType = Key === 'Ring' ? 'ShankMetalColour' : 'HeadMetalColour';

            if(colorType == 'HeadMetalColour'){
                const filteredColors = metalComponentColor.filter(item => item !== 'ShankMetalColour');
                await handleMetalColorHologram(metal_color, filteredColors.join(''), 1);
            }else{
                await handleMetalColorHologram(metal_color, colorType, 1);
            }
        }
        // Prices will be fetched by useEffect watching state changes
    }

    const handleMetalColorChange = async(value,Key) => {
        Key === 'Ring' ? setRingColor(value) : setSettingColor(value);

        const metal_color = CONSTANT.MetalColorShank[value];
        const colorType = Key === 'Ring' ? 'ShankMetalColour' : 'HeadMetalColour';

        if(colorType == 'HeadMetalColour'){
            const filteredColors = metalComponentColor.filter(item => item !== 'ShankMetalColour');
            await handleMetalColorHologram(metal_color, filteredColors.join(''), 1);
        }else{
            await handleMetalColorHologram(metal_color, colorType, 1);
        }
    }

    const handleDiamondQuality = (value,Key) => {
        Key === 'Ring' ? setRingQuality(value) : setSettingQuality(value);
        // Prices will be fetched by useEffect watching state changes
    }

    const handleFingerSizeChange = (value) =>{
        setFingerSize(value);
    }

    const handleCenterStoneShape = (value,id) => {
        setLoadingContentCanvas(true);
        setCenterStoneShape(value);
        setCenterStoneShapeId(id);
        // Lists and details will be fetched by useEffect
    }

    const handleHeadItemDetail = (value,id) => {
        setLoadingContentCanvas(true);
        setHeadItemDetail(value);
        setHeadItemId(id);
    }

    const handleShangItemDetail = (value,id) => {
        setLoadingContentCanvas(true);
        setShangItemDetail(value);
        setShangItemId(id);
    }

    const handleCenterStoneChange = (index) =>{
        const value = STONE_SIZE_OPTIONS[index];
        setCenterStoneSize(value);
        setCenterStoneWeight(value);
    }

    // Syncs Center Stone Size to the closest available option when the popup's
    // Stone Size filter changes, or when a diamond is actually selected.
    const syncCenterStoneSizeToCarat = (caratOrSize) => {
        const numeric = parseFloat(caratOrSize);
        if (isNaN(numeric)) return;
        const closest = STONE_SIZE_OPTIONS.reduce((best, opt) =>
            Math.abs(parseFloat(opt) - numeric) < Math.abs(parseFloat(best) - numeric) ? opt : best
        );
        setCenterStoneSize(closest);
        setCenterStoneWeight(closest);
    }
    const toggleDiamondModal = () => {
        setIsModalDiamondOpen(!isModalDiamondOpen);
    };

    /*Drop Hint Model function*/
    const [isModalDropHintOpen, setisModalDropHintOpen] = useState(false);
    const toggleDropHintModal = () =>{
      setisModalDropHintOpen(!isModalDropHintOpen);
    }
    const [isModalSaveWishlistOpen, setIsModalSaveWishlistOpen] = useState(false);
    const [wishlistCanvasImage, setWishlistCanvasImage] = useState(null);

    const toggleSaveWishlistModal = () => {
      setIsModalSaveWishlistOpen(!isModalSaveWishlistOpen);
    }

    const handleOpenSaveWishlist = (e) => {
        e.preventDefault();
        let imageData = null;
        if (canvasRef.current) {
            try {
                imageData = canvasRef.current.toDataURL('image/png');
            } catch (err) {
                console.error('Canvas capture failed:', err);
            }
        }
        setWishlistCanvasImage(imageData);
        setIsModalSaveWishlistOpen(true);
    }

    const handleSelectedDiamondDetails = (diamondDetails) => {
        if (diamondDetails) {
            setselectedDiamondDetails(diamondDetails);
            // Parse the price - handle both numeric and string formats
            const price = diamondDetails.prices || diamondDetails.display_pricing || 0;
            const numericPrice = typeof price === 'string'
                ? parseFloat(price.replace(/[^0-9.-]+/g, ''))
                : parseFloat(price);
            setDiamondPriceDetails(isNaN(numericPrice) ? 0 : numericPrice);
            syncCenterStoneSizeToCarat(diamondDetails.carat);
        } else {
            setselectedDiamondDetails(null);
            setDiamondPriceDetails(0);
        }
    }

    const getShapeDetails = async () => {
        if (!accessToken) {
            console.warn("Access token is not available. Skipping getShapeDetails request.");
            return;
        }
        try {
            setCenterShapeLoading(true);
            const response = await axios.post(
                `${CONSTANT.BASE_URL}api/Builder/get-shape`,
                { client_code }
            );
            const images = response.data.map((item) => ({
                src: `images/hologram-shape/`+item.name+`-1.png`,
                text: item.name,
                id: item.id,
            }));
            setCenterStoneShapeList(images);
            setCenterStoneShapeId(images[0]?.id);
        } catch (err) {
            console.error("Failed to fetch shapes:", err);
        } finally {
            setCenterShapeLoading(false);
        }
    };

    const getItemHeadList = async (centerStone = null) => {
        if (!accessToken) {
            console.warn("Access token is not available. Skipping getItemHeadList request.");
            return;
        }
        try {
            setHeadLoading(true);
            const shape_id = centerStone || centerStoneShape || 'Round';
            const payload = {
                category: 'SingleRingBuilder',
                client_code,
                layer_code: 'Layer 1',
                shape_id
            };
            const response = await axios.post(`${CONSTANT.BASE_URL}api/Builder/get-Item`, payload);
            const headSuffix = colorSuffixMap[ringColor] ?? '';
            const item_images = response.data.map((item) => ({
                src: `uploads/RingBuilder/head_images/${item.product_code}${headSuffix}.png`,
                text: item.product_code,
                id: item.id,
            }));

            setItemHeadList(item_images);
            if(centerStone === null && item_images[0]){
                setHeadItemDetail(item_images[0].text);
                setHeadItemId(item_images[0].id);
            }
        } catch (err) {
            console.error("Failed to fetch head items:", err);
        } finally {
            setHeadLoading(false);
        }
    };

    const getItemShangList = async (centerStone = null) => {
        if (!accessToken) {
            console.warn("Access token is not available. Skipping getItemShangList request.");
            return;
        }
        try {
            setShangLoading(true);
            const shape_id = centerStone || centerStoneShape || 'Round';
            const payload = {
                category: 'SingleRingBuilder',
                client_code,
                layer_code: 'Layer 2',
                shape_id
            };
            const response = await axios.post(`${CONSTANT.BASE_URL}api/Builder/get-Item`, payload);
            const shankSuffix = colorSuffixMap[ringColor] ?? '';
            const item_images = response.data.map((item) => ({
                src: `uploads/RingBuilder/shank_images/${item.product_code}${shankSuffix}.png`,
                text: item.product_code,
                id: item.id,
            }));

            setItemShangList(item_images);
            if(centerStone === null && item_images[0]){
                setShangItemDetail(item_images[0].text);
                setShangItemId(item_images[0].id);
            }
        } catch (err) {
            console.error("Failed to fetch shang items:", err);
        } finally {
            setShangLoading(false);
        }
    };

    const FetchItemDetailsCombinedWithParams = async(head_id = null, shang_id = null, stone_shape = null) => {
        console.log("Initial Color Code",initialMetalColor );
        if (!accessToken) {
            console.warn("Access token is not available. Skipping FetchItemDetailsCombinedWithParams request.");
            return;
        }
        setLoadingContent(true);
        const baseUrl = `${CONSTANT.BASE_URL}api/Builder/get-final-product-details`;
        const { category, account_no: client_code } = window.Builder_Data;
        try {
            if(head_id == null && shang_id == null && stone_shape == null){
                setRingCategoryItem('');
            }
            // Use passed parameters if available, otherwise fall back to state
            const finalHeadId = head_id !== null ? head_id : headItemId;
            const finalShangId = shang_id !== null ? shang_id : shangItemId;
            const finalStoneShape = stone_shape !== null ? stone_shape : centerStoneShape;

            if (!isValidValue(finalHeadId) || !isValidValue(finalShangId) || !isValidValue(finalStoneShape)) {
                console.warn("Head ID, Shang ID, or Stone Shape is missing or empty. Cannot fetch item details.");
                setLoadingContent(false);
                return;
            }

            const finalConditionResponses = await axios.post( `${CONSTANT.BASE_URL}api/Builder/get-final-item-details`,
            {
                item_code: finalHeadId+','+finalShangId,
                account_no: client_code,
                category: 'SingleRingBuilder',
                stone_shape: finalStoneShape,
                metal_color: ringColor
            });

            if(finalConditionResponses?.data?.shahluxe?.image_list.length > 0){
                setImageList(finalConditionResponses?.data?.shahluxe?.image_list);
                setCurrentImage(finalConditionResponses?.data?.shahluxe?.image_list[0]);
            }

            // Only set GLB file if glb_file_path is valid
            const glbFilePath = finalConditionResponses?.data?.item_details?.glb_file_path;
            if (glbFilePath && glbFilePath !== 'undefined' && glbFilePath.trim() !== '') {
                setglbFiles(glbFilePath + '.glb');
            } else {
                console.warn('Invalid or missing GLB file path:', glbFilePath);
                setglbFiles(''); // Clear the GLB file
            }

            setShahApiProduct(finalConditionResponses?.data?.shahluxe?.shah_api_product[0]);
            setitemDetails(finalConditionResponses?.data?.item_details);
            setItemHeadDetails(finalConditionResponses?.data?.item_head);
            setItemShangDetails(finalConditionResponses?.data?.item_shang);
            // getHologram(finalConditionResponses?.data?.item_details?.glb_file_path+'.glb');

        } catch (error) {
            console.error('Error fetching items:', error);
        } finally {
            setLoadingContent(false);
        }
    }

    const FetchItemDetailsCombined= async() => {
        // Call the new function with state values
        await FetchItemDetailsCombinedWithParams();
    }

    const FetchItemDetailsCombinedByName = async(item_name, item_id)=>{
        console.log('FetchItemDetailsCombinedByName called with:', { item_name, item_id, item_name_type: typeof item_name, item_id_type: typeof item_id });

        if (!accessToken) {
            console.warn("Access token is not available. Skipping FetchItemDetailsCombinedByName request.");
            return;
        }

        if (!isValidValue(item_name) || !isValidValue(item_id)) {
            console.warn("Item name or item ID is missing or empty. Cannot fetch item details.");
            return;
        }

        setLoadingContent(true);
        try {
            setRingCategoryItem(item_name);
            const finalConditionResponses = await axios.post(`${CONSTANT.BASE_URL}api/Builder/get-final-item-name`, {
                item_name: item_name,
                item_id: item_id
            });

            const { head_id, shang_id, ShapeName, HeadName, ShangName } = finalConditionResponses.data;

            // Set flag to prevent useEffect from triggering duplicate fetch
            skipFetchRef.current = true;

            await setCenterStoneShape(ShapeName);
            await setHeadItemId(head_id);
            await setShangItemId(shang_id);
            await setHeadItemDetail(HeadName);
            await setShangItemDetail(ShangName);

            // Fetch lists with the correct shape and product details in parallel
            await Promise.all([
                getItemHeadList(ShapeName),
                getItemShangList(ShapeName),
                FetchItemDetailsCombinedWithParams(head_id, shang_id, ShapeName)
            ]);
            // Reset after a tick so React flushes pending state effects first
            setTimeout(() => { skipFetchRef.current = false; }, 0);

        } catch (error) {
            console.error('Error fetching items:', error);
            skipFetchRef.current = false;
        } finally {
            setLoadingContent(false);
        }
    }

    const FetchShangPrices = async() =>{
        if (!accessToken) {
            console.warn("Access token is not available. Skipping FetchShangPrices request.");
            return;
        }
        if(itemShangDetails?.item_no){
            setLoadingItemPricesItemPrices(true);
            const apiParams = {
                metal_type:         settingType,
                product_code:       itemShangDetails?.item_no,
                account_no:         client_code,
                category:           'Ring Builder',
                metal_color:        settingColor,
                diamond_quality:    settingQuality,
                center_stone_weight: centerStoneSize,
                center_stone_shape: centerStoneShape
            };
            try {
                const priceResponse = await axios.post( `${CONSTANT.BASE_URL}api/Builder/fetch-item-prices`, { apiParams } );
                const price = priceResponse.data.message;
                setShangPrices(price);
            } catch (error) {
                console.error('Error fetching product price:', error);
            } finally {
                setLoadingItemPricesItemPrices(false);
            }
        }
    }

    const FetchHeadPrices = async() =>{
        if (!accessToken) {
            console.warn("Access token is not available. Skipping FetchHeadPrices request.");
            return;
        }
        setLoadingItemPricesItemPrices(true);
        if(itemHeadDetails?.item_no){
            const apiParams = {
                metal_type:          ringType,
                product_code:        itemHeadDetails?.item_no,
                account_no:          client_code,
                category:            'Ring Builder',
                metal_color:         ringColor,
                diamond_quality:     ringQuality,
                center_stone_weight: centerStoneSize,
                center_stone_shape: centerStoneShape
            };
            try {
                const priceResponse = await axios.post( `${CONSTANT.BASE_URL}api/Builder/fetch-item-prices`, { apiParams } );
                const price = priceResponse.data.message;
                setHeadPrices(price);
            } catch (error) {
                console.error('Error fetching product price:', error);
            } finally {
                setLoadingItemPricesItemPrices(false);
            }
        }
    }

    const UpdatedSelectedGlobalItemId = () => {
        if (itemDetails && Object.keys(itemDetails).length > 0) {
            const updatedItemDetails = {
                ...itemDetails,
                thumb_image: currentImage,
                product_name: shahApiProduct?.product_name_sp
            };

            updatedSelectedItemDetails({
                ...basketItemData,
                itemDetails: updatedItemDetails
            });
        }
    }

    const handleAddToBasket = (e) => {
        e?.preventDefault();
        setBasketError(null);
        if (itemDetails && Object.keys(itemDetails).length > 0) {
            try {
                const updatedItemDetails = {
                    ...itemDetails,
                    thumb_image: currentImage,
                    product_name: shahApiProduct?.product_name_sp
                };

                const basketItem = {
                    ...basketItemData,
                    itemDetails: updatedItemDetails
                };

                addToBasket(basketItem);
                setIsInBasket(true);
                UpdatedSelectedGlobalItemId();

                if(isInBasket){
                    handlePagesChanges('BasketPreview');
                }
            } catch (err) {
                setBasketError('Sorry, something went wrong: Failed to create product');
            }
        } else {
            setBasketError('Sorry, something went wrong: Failed to create product');
        }
    }

    const handleDropHitModel = (e) =>{
        UpdatedSelectedGlobalItemId();
        toggleDropHintModal();
    };

    const getRingCategory = async(value)=>{
        if (!accessToken) {
            console.warn("Access token is not available. Skipping getRingCategory request.");
            return;
        }
        try {
            setCategoryLoading(true);
            setRingCategory(value);

            // Scroll to top when ring category changes

            const postCategory = await axios.post(`${CONSTANT.BASE_URL}api/Builder/fetchRingCategory`, {
                apiParams: { ring_category: value }
            });
            setRingCategoryList(postCategory.data);
            if (ringColor !== "White Gold") {
                const suffix = colorSuffixMap[ringColor] ?? '';
                setRingCategoryList(prev => prev.map(item => ({
                    ...item,
                    src: `https://hologram.shahluxe.com/images/Ring-Builder/${item.item_no}${suffix}.png`,
                })));
            }
        } catch (error) {
            console.error('Error fetching ring category:', error);
        } finally {
            setCategoryLoading(false);
        }
    }

    // Initial data loading - only runs once when accessToken is available
    useEffect(() => {
        if (!accessToken) return;

        const loadInitialData = async () => {
            if (initialSelectedItem) {
                // Block shape-change effect so it doesn't fetch lists with wrong shape
                skipFetchRef.current = true;
                await Promise.all([
                    getShapeDetails(),
                    getRingCategory(initialRingCategory),
                ]);
                // FetchItemDetailsCombinedByName fetches lists + product with correct shape, then resets skipFetchRef
                await FetchItemDetailsCombinedByName(initialSelectedItem.name, initialSelectedItem.id);
                return;
            }

            const promises = [getShapeDetails()];

            // Only add getRingCategory if client_code is 'W284'
            if (client_code === 'W284') {
                promises.push(getRingCategory(initialRingCategory));
            }

            await Promise.all(promises);
        };
        loadInitialData();
    }, [accessToken]);

    // Window resize handler - separate effect for clarity
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch prices when item details are available
    useEffect(() => {
        if (!itemShangDetails?.item_no || !itemHeadDetails?.item_no) return;

        const fetchPrices = async () => {
            await Promise.all([
                FetchShangPrices(),
                FetchHeadPrices()
            ]);
        };
        fetchPrices();
    }, [itemShangDetails?.item_no, itemHeadDetails?.item_no, ringType, settingType, ringColor, settingColor, ringQuality, settingQuality]);

    // Fetch item lists when center stone shape or ring color changes
    useEffect(() => {
        if (skipFetchRef.current || !isValidValue(centerStoneShapeId)) return;

        const fetchLists = async () => {
            await Promise.all([
                getItemHeadList(),
                getItemShangList()
            ]);
        };
        fetchLists();
    }, [centerStoneShapeId, ringColor]);

    // Fetch combined details when head or shank items change
    useEffect(() => {
        if (skipFetchRef.current || !isValidValue(headItemId) || !isValidValue(shangItemId)) return;

        // Debounce: if both IDs update in the same tick (e.g. shape change), fire only once
        clearTimeout(fetchDebounceRef.current);
        fetchDebounceRef.current = setTimeout(() => {
            FetchItemDetailsCombined();
        }, 0);
    }, [headItemId, shangItemId]);

    // Fetch prices when stone size changes
    useEffect(() => {
        if (!headItemId || !shangItemId) return;

        const fetchPricesOnSizeChange = async () => {
            await Promise.all([
                FetchHeadPrices(),
                FetchShangPrices()
            ]);
        };
        fetchPricesOnSizeChange();
    }, [centerStoneSize]);

    // Load hologram when GLB file changes
    useEffect(() => {
        if (!glbFiles || !canvasRef.current) return;

        const loadHologram = async () => {
            removeInstalizeViewwer();
            setLoadingContentCanvas(true);
            try {
                const module = await getHologram(glbFiles, canvasRef.current);
                setLoadingContentCanvas(false);
                var head_metal_color = CONSTANT.MetalColorShank[settingColor];
                var shank_metal_color = CONSTANT.MetalColorShank[ringColor];

                // Set default stone color if available
                const stoneOptions = module?.components?.stoneOptions || [];
                const metalOptions = module?.components?.metalOptions || [];
                
                if (metalOptions[0]) {
                    const [material, component] = metalOptions[0].split('#');
                    var changeMetalColor = metalOptions[0].split('#');
                    changeMetalColor = changeMetalColor[1].split(',');
                    await setMetalComponentColor(changeMetalColor)
                    // Apply colors in parallel
                    changeMetalColor = changeMetalColor.filter(item => item !== 'ShankMetalColour');                    
                    await Promise.all([
                        handleMetalColorHologram(shank_metal_color, 'ShankMetalColour', 1),                        
                        handleMetalColorHologram(head_metal_color, changeMetalColor.join(''), 1),
                        handleStoneColorHologram('diamond.dmat', 'CenterStone')
                    ]);
                }

                if (stoneOptions[0]) {
                    const [material, component] = stoneOptions[0].split('#');
                    await handleStoneColorHologram(material, component);
                }
            } catch (error) {
                setLoadingContentCanvas(false);
                console.error('Error loading hologram:', error);
            }
        };
        loadHologram();
        console.log("Layer Param Details:",layerparam);
    }, [glbFiles]);
    
    useEffect(() => {
        const fetchProductInformation = async () => {
            await setIsReceDiamond(golbalClientDetails?.client_id[0]?.is_rec_dia);
            await setProductInformation(golbalClientDetails?.client_id[0]?.disable_instruction);
            const parsedColorCodes = golbalClientDetails.client_id[0].color_code.split(',').map(c => c.trim()).filter(c => c !== '');
            setColorCode(parsedColorCodes[0]);
        }
        fetchProductInformation();
    },[golbalClientDetails]);

    const METAL_SWATCHES = [
        { label: 'White Gold',  color: '#e8e8e8', border: '#bbb' },
        { label: 'Yellow Gold', color: '#fae1a1', border: '#c9a830' },
        { label: 'Rose Gold',   color: '#fddfbd', border: '#c97060' },
        { label: 'Platinum',    color: '#d4d4e0', border: '#9090aa' },
    ];

    const renderSwatches = (activeColor, onClick) => (
        <div style={{ display: 'flex', gap: '8px', marginTop: '6px', flexWrap: 'wrap' }}>
            {METAL_SWATCHES.map(swatch => (
                <div
                    key={swatch.label}
                    title={swatch.label}
                    onClick={() => onClick(swatch.label)}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
                >
                    <div style={{
                        width: '24px', height: '24px', borderRadius: '50%',
                        backgroundColor: swatch.color,
                        border: activeColor === swatch.label ? `3px solid ${swatch.border}` : `2px solid ${swatch.border}`,
                        boxShadow: activeColor === swatch.label ? `0 0 0 2px #fff, 0 0 0 4px ${swatch.border}` : 'none',
                        transition: 'box-shadow 0.2s',
                        flexShrink: 0,
                    }} />
                    <span style={{
                        fontSize: '9px', textAlign: 'center', lineHeight: '1.2',
                        color: activeColor === swatch.label ? swatch.border : '#666',
                        fontWeight: activeColor === swatch.label ? '700' : '400',
                        whiteSpace: 'nowrap',
                    }}>
                        {swatch.label}
                    </span>
                </div>
            ))}
        </div>
    );

    const HeadIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="50" viewBox="0 0 70 50" style={{ display: 'inline-block', verticalAlign: 'middle', margin: '0 3px' }}>
            <path d="M 22.028 14.471 C 20.365 16.240, 19.993 17.305, 20.717 18.221 C 22.398 20.349, 21.802 23.368, 19.313 25.325 C 16.573 27.481, 13.452 33, 14.974 33 C 15.538 33, 16 32.352, 16 31.559 C 16 30.766, 16.498 29.810, 17.107 29.434 C 17.864 28.966, 17.984 29.475, 17.486 31.044 C 16.924 32.814, 17.665 32.386, 20.724 29.169 C 24.171 25.546, 25.250 25, 28.963 25 C 32.601 25, 33.818 25.583, 37.162 28.926 C 39.945 31.710, 40.899 32.256, 40.437 30.801 C 40.002 29.432, 40.154 28.977, 40.893 29.434 C 41.502 29.810, 42 30.766, 42 31.559 C 42 32.352, 42.462 33, 43.026 33 C 44.412 33, 41.760 27.998, 39.096 25.587 C 37.937 24.538, 36.727 23.940, 36.408 24.258 C 36.089 24.577, 36.767 25.340, 37.914 25.954 C 39.061 26.568, 40 27.545, 40 28.124 C 40 28.704, 38.570 27.975, 36.823 26.504 C 34.156 24.260, 32.911 23.896, 29.073 24.238 C 26.558 24.462, 23.600 24.987, 22.500 25.404 C 20.576 26.134, 20.571 26.106, 22.350 24.648 C 23.428 23.766, 23.885 22.623, 23.446 21.912 C 22.921 21.063, 23.119 20.943, 24.095 21.517 C 24.868 21.972, 24.600 21.314, 23.500 20.056 L 21.500 17.768 23.500 18.165 C 24.813 18.426, 25.473 19.324, 25.421 20.781 C 25.353 22.683, 25.864 23, 29 23 C 32.136 23, 32.647 22.683, 32.579 20.781 C 32.527 19.324, 33.187 18.426, 34.500 18.165 L 36.500 17.768 34.500 20.056 C 33.400 21.314, 33.057 22.018, 33.739 21.620 C 34.575 21.131, 34.784 21.400, 34.382 22.448 C 34.054 23.302, 34.284 24, 34.893 24 C 35.932 24, 36.433 22.590, 36.083 20.645 C 35.999 20.174, 36.462 19.149, 37.112 18.365 C 38.050 17.234, 37.816 16.433, 35.972 14.471 C 32.670 10.955, 25.330 10.955, 22.028 14.471 M 23.500 14.610 C 21.541 16.125, 21.550 16.151, 23.922 15.829 C 25.254 15.648, 26.529 14.938, 26.755 14.250 C 27.308 12.572, 25.940 12.723, 23.500 14.610 M 31.245 14.250 C 31.471 14.938, 32.746 15.648, 34.078 15.829 C 36.450 16.151, 36.459 16.125, 34.500 14.610 C 32.060 12.723, 30.692 12.572, 31.245 14.250 M 27.688 14.646 C 26.467 15.866, 26.952 16.571, 29.012 16.571 C 30.118 16.571, 30.878 16.133, 30.699 15.598 C 30.273 14.320, 28.556 13.777, 27.688 14.646 M 26.638 19.500 C 26.955 20.325, 28.018 21, 29 21 C 29.982 21, 31.045 20.325, 31.362 19.500 C 31.793 18.376, 31.200 18, 29 18 C 26.800 18, 26.207 18.376, 26.638 19.500 M 18.459 27.067 C 17.383 28.808, 18.608 29.177, 19.980 27.524 C 20.769 26.574, 20.845 26, 20.181 26 C 19.597 26, 18.821 26.480, 18.459 27.067" stroke="none" fill={colorCode} fillRule="evenodd" />
        </svg>
    );

    const ShankIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="50" viewBox="0 0 70 50" style={{ display: 'inline-block', verticalAlign: 'middle', margin: '0 3px' }}>
            <path d="M 31.498 11.716 C 29.890 12.966, 29.841 13.152, 31.250 12.666 C 32.212 12.334, 33 12.499, 33 13.031 C 33 13.564, 30.940 14, 28.423 14 C 24.698 14, 23.302 14.544, 20.923 16.923 C 17.497 20.349, 16.964 19.758, 20.250 16.177 C 21.704 14.593, 21.969 13.884, 21 14.172 C 18.464 14.928, 14.592 23.240, 15.357 26.288 C 16.076 29.153, 21.579 36, 23.163 36 C 23.688 36, 23.900 35.646, 23.632 35.214 C 23.365 34.782, 25.556 34.429, 28.500 34.429 C 31.444 34.429, 33.607 34.827, 33.306 35.314 C 33.005 35.801, 33.737 35.676, 34.933 35.036 C 38.145 33.317, 40.992 28.018, 40.996 23.753 C 40.999 20.895, 40.195 19.115, 37.609 16.253 C 35.745 14.189, 34.207 12.125, 34.193 11.667 C 34.145 10.139, 33.514 10.150, 31.498 11.716 M 22 12.500 C 22 13.325, 22.450 14, 23 14 C 23.550 14, 24 13.523, 24 12.941 C 24 12.359, 24.520 12.203, 25.155 12.595 C 25.870 13.038, 26.038 12.870, 25.595 12.155 C 24.565 10.488, 22 10.734, 22 12.500 M 34.633 15.772 C 39.652 19.838, 40.396 26.188, 36.408 30.927 C 34.982 32.622, 34.443 33.767, 35.211 33.473 C 37.484 32.600, 40 27.452, 40 23.672 C 40 20.062, 36.003 13.977, 33.661 14.022 C 33.022 14.034, 33.460 14.822, 34.633 15.772 M 21.687 17.805 C 18.305 21.335, 18.092 26.519, 21.161 30.615 L 23.322 33.500 20.959 31.270 C 19.422 29.820, 18.364 27.374, 17.932 24.270 L 17.267 19.500 17.156 24 C 16.996 30.478, 19.436 33.292, 25.521 33.646 C 30.726 33.948, 35.342 32.098, 36.970 29.055 C 40.304 22.827, 35.455 15, 28.264 15 C 25.308 15, 23.729 15.673, 21.687 17.805 M 26.813 36.683 C 27.534 36.972, 28.397 36.936, 28.729 36.604 C 29.061 36.272, 28.471 36.036, 27.417 36.079 C 26.252 36.127, 26.015 36.364, 26.813 36.683" stroke="none" fill={colorCode} fillRule="evenodd" />
        </svg>
    );

    const handlePageAppointment = () =>{
        UpdatedSelectedGlobalItemId();
        handlePagesChanges('AppointmentSchedule');
    }

    return(
        <div className='row build-ring-main-page'>
            {windowWidth <= 950 &&
                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <div className="product_details_title text-center" style={{marginTop:'15px'}}>
                        <h6><b>As You Wish Ring Builder</b></h6>
                    </div>
                </div>
            }
            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                <div className={`row ${windowWidth <= 950 ? 'mobile-sticky-wrapper' : ''}`}>
                    <div className={`col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 mobile-sticky-wrapper`}>
                        <div className='row'>
                            <div className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12`}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <tbody>
                                        {client_code != 'W284' ? (
                                            <tr>
                                                <td>
                                                    <div style={{ display: 'flex', gap: '20px', width: '100%', height: '650px', position:`relative`}} id="viewer-container">
                                                        {loadingContentCanvas && (
                                                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}>
                                                                <SpinnerComponent />
                                                            </div>
                                                        )}
                                                        <canvas id="mcanvas" ref={canvasRef} style={{ width: '100%!important', height: '650px!important' }} />
                                                        <div className='text-field-diamond' style ={{ textAlign: 'center', marginTop: '10px', fontSize: '20px', color: '#666', position:`absolute`,bottom:`0px`,left:`15px`}}>
                                                            Shown with 1ct center diamond
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ):(
                                            <tr>
                                                <td>
                                                    <div style={{ display: 'flex', gap: '20px', width: '100%', height: '650px', position:`relative`}} id="viewer-container">
                                                        {loadingContentCanvas && (
                                                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}>
                                                                <SpinnerComponent />
                                                            </div>
                                                        )}
                                                        <canvas id="mcanvas" ref={canvasRef} style={{ width: '100%!important', height: '650px!important' }} />
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {windowWidth >= 950 && (
                                                    <>
                                                        {productInformation == "No" && client_code != 'W284' && (
                                                            <tr>
                                                                <td>
                                                                    <h6 style={{textTransform: 'uppercase', textAlign: 'justify', lineHeight: '18px',paddingLeft: '20px', paddingRight: '20px',fontSize: '1rem',fontWeight: 'bold'}}>
                                                                        Product Knowledge
                                                                    </h6>
                                                                    <hr />
                                                                    <p className="prdesclaimer" style={{textAlign: 'justify',lineHeight: '18px',paddingLeft: '20px',paddingRight: '20px',fontSize:'14px'}}>
                                                                        We pride ourselves on the meticulous attention placed on design and the precision of the engineered components. However, due to the inherent nature of the materials used and handcrafted finish out, please understand that from time to time there may be a slight fluctuation in materials tolerance. This fluctuation is due in part to several factors which may include different fabrication and production dates of like pieces, necessary adjustments needed to accommodate slight variations in gem makes and cuts and the hand fabrication component. We guarantee our gem weights to be exact or understated. We also guarantee our metal karat weights to be precise and as noted. Product photography in print material and website may not reflect exact true color and/or scale.
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            { windowWidth >= 950 && (
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='row'>
                                                {client_code == 'W284' && (
                                                    <>
                                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                            <div className='product_details text-center' style={{marginTop:'20px',marginBottom: '6px'}}>
                                                                {shahApiProduct?.product_name_sp != "" && ( <h9><b>{shahApiProduct?.product_name_sp}</b></h9> )}
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        {windowWidth <= 950 ? (
                                                            <>
                                                                <div className='col-12' style={{padding:`0px`}}>
                                                                    <b>Ring</b>
                                                                </div>
                                                                <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-metal-final' style={{padding:`0px`}}>
                                                                    <div className='form-group'>
                                                                        <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Ring')} selectedValue={ringType} name="ring_type" labelName={'Metal Type'} />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ):(
                                                            <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-metal-final' style={{padding:`0px`}}>
                                                                <div className='form-group'>
                                                                    <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Ring')} selectedValue={ringType} name="ring_type" labelName={'Ring-Metal'} />
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-color-final' style={{padding:`0px`}}>
                                                            <div className='form-group'>
                                                            <label><span style={{ color: 'red' }}>*</span>{windowWidth <= 950 ? 'Metal Color' : 'Ring-Metal Color'}:</label>
                                                            {renderSwatches(ringColor, (value) => handleMetalColorChange(value, 'Ring'))}
                                                            </div>
                                                        </div>
                                                        <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-diamond-final' style={{padding:`0px`}}>
                                                            <div className='form-group'>
                                                                <CommonFilter filterKey='diamond_quality' inputType='select' onChange={(value) => handleDiamondQuality(value,'Ring')} selectedValue={ringQuality} name="ring_quality" labelName={windowWidth <= 950 ? 'Diamond Quality' : 'Ring-Diamond Quality'} />
                                                            </div>
                                                        </div>
                                                        {windowWidth <= 950 ? (
                                                            <>
                                                                <div className='col-12' style={{padding:`0px`,marginTop:`20px`}}>
                                                                    <b>Setting</b>
                                                                </div>
                                                                <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-type-final' style={{padding:`0px`}}>
                                                                    <div className='form-group'>
                                                                        <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Setting')} selectedValue={settingType} name="setting_type" labelName={'Metal Type'} />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ):(
                                                            <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-type-final' style={{padding:`0px`}}>
                                                                <div className='form-group'>
                                                                    <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Setting')} selectedValue={settingType} name="setting_type" labelName={'Setting-Metal'} />
                                                                </div>
                                                            </div>

                                                        )}
                                                        <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-color-final' style={{padding:`0px`}}>
                                                            <div className='form-group'>
                                                                <label><span style={{ color: 'red' }}>*</span>{windowWidth <= 950 ? 'Metal Color' : 'Setting-Metal Color'}:</label>
                                                                {renderSwatches(settingColor, (value) => handleMetalColorChange(value, 'Setting'))}
                                                            </div>
                                                        </div>
                                                        <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-diamond-final' style={{padding:`2px`}}>
                                                            <div className='form-group'>
                                                                <CommonFilter filterKey='diamond_quality' inputType='select'onChange={(value) => handleDiamondQuality(value,'Setting')} selectedValue={settingQuality} name="setting_quality" labelName={windowWidth <= 950 ? 'Diamond Quality' : 'Setting-Diamond Quality'} />
                                                            </div>
                                                        </div>
                                                        <div className='col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 center-stone-final' style={{padding:`0px`}}>
                                                            <div className='form-group'>
                                                                <div className="col-12 center-stone-selector" style={{ padding: "5px" }}>
                                                                    <label className="control-label"><span style={{color:`red`}}>*</span>Center Stone Size:</label>
                                                                    <span style={{fontSize:`small`}}>(Center Stone Not Included) &nbsp;</span>
                                                                    <div style={{ padding: "10px 10px 20px 10px" }}>
                                                                        <Slider min={0} max={STONE_SIZE_OPTIONS.length - 1} step={1} value={STONE_SIZE_OPTIONS.indexOf(centerStoneSize)} onChange={handleCenterStoneChange} marks={STONE_SIZE_MARKS} dotStyle={{ borderColor: colorCode }} activeDotStyle={{ borderColor: colorCode }} trackStyle={{ backgroundColor: colorCode, height: 4 }} handleStyle={{ borderColor: colorCode, height: 24, width: 24, marginTop: -10, backgroundColor: colorCode }} railStyle={{ backgroundColor: colorCode, height: 4 }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 finger-size-final' style={{padding:`2px`}}>
                                                            <div className='form-group'>
                                                                <FingerSize fingerSize={fingerSize} onChange={handleFingerSizeChange} labelName="Finger Size"  />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                            )}
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5' style={{marginTop:'10px'}}>
                        <div className='row'>
                            {windowWidth >= 950 &&
                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                    <div className="product_details_title text-center" style={{marginTop:'15px'}}>
                                        <h6><b>As You Wish Ring Builder</b></h6>
                                    </div>
                                </div>
                            }
                            {(client_code != 'W284') && (
                                <>
                                    <hr />
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                        <div className='product_details text-center' style={{marginTop:'20px',marginBottom: '6px'}}>
                                            {shahApiProduct?.product_name_sp != "" && ( <h9><b>{shahApiProduct?.product_name_sp}</b></h9> )}
                                        </div>
                                    </div>
                                    {windowWidth <= 950 ? (
                                        <>
                                            <div className='col-12' style={{padding:`0px`}}>
                                                <b>Ring</b>
                                            </div>
                                            <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-metal-final' style={{padding:`0px`}}>
                                                <div className='form-group'>
                                                    <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Ring')} selectedValue={ringType} name="ring_type" labelName={'Metal Type'} />
                                                </div>
                                            </div>
                                        </>
                                    ):(
                                        <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-metal-final' style={{padding:`0px`}}>
                                            <div className='form-group'>
                                                <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Ring')} selectedValue={ringType} name="ring_type" labelName={'Ring-Metal'} />
                                            </div>
                                        </div>
                                    )}
                                    <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-color-final' style={{padding:`0px`}}>
                                        <div className='form-group'>
                                            <label><span style={{ color: 'red' }}>*</span>{windowWidth <= 950 ? 'Metal Color' : 'Ring-Metal Color'}:</label>
                                            {renderSwatches(ringColor, (value) => handleMetalColorChange(value, 'Ring'))}
                                        </div>
                                    </div>
                                    <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-diamond-final' style={{padding:`0px`}}>
                                        <div className='form-group'>
                                            <CommonFilter filterKey='diamond_quality' inputType='select' onChange={(value) => handleDiamondQuality(value,'Ring')} selectedValue={ringQuality} name="ring_quality" labelName={windowWidth <= 950 ? 'Diamond Quality' : 'Ring-Diamond Quality'} />
                                        </div>
                                    </div>
                                    {windowWidth <= 950 ? (
                                        <>
                                            <div className='col-12' style={{padding:`0px`,marginTop:`20px`}}>
                                                <b>Setting</b>
                                            </div>
                                            <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-type-final' style={{padding:`0px`}}>
                                                <div className='form-group'>
                                                    <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Setting')} selectedValue={settingType} name="setting_type" labelName={'Metal Type'} />
                                                </div>
                                            </div>
                                        </>
                                    ):(
                                        <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-type-final' style={{padding:`0px`}}>
                                            <div className='form-group'>
                                                <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Setting')} selectedValue={settingType} name="setting_type" labelName={'Setting-Metal'} />
                                            </div>
                                        </div>
                                    )}
                                    <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-color-final' style={{padding:`0px`}}>
                                        <div className='form-group'>
                                            <label><span style={{ color: 'red' }}>*</span>{windowWidth <= 950 ? 'Metal Color' : 'Setting-Metal Color'}:</label>
                                            {renderSwatches(settingColor, (value) => handleMetalColorChange(value, 'Setting'))}
                                        </div>
                                    </div>
                                    <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-diamond-final' style={{padding:`2px`}}>
                                        <div className='form-group'>
                                            <CommonFilter filterKey='diamond_quality' inputType='select'onChange={(value) => handleDiamondQuality(value,'Setting')} selectedValue={settingQuality} name="setting_quality" labelName={windowWidth <= 950 ? 'Diamond Quality' : 'Setting-Diamond Quality'} />
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 center-stone-final' style={{padding:`0px`}}>
                                        <div className='form-group'>
                                            <div className="col-12 center-stone-selector" style={{ padding: "5px" }}>
                                                <label className="control-label"><span style={{color:`red`}}>*</span>CENTER STONE SIZE:</label>
                                                <span style={{fontSize:`small`}}>(Center Stone Not Included)</span>
                                                {windowWidth <= 950 ? (
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                                        {STONE_SIZE_OPTIONS.map((size, idx) => (
                                                            <button key={size}
                                                                    onClick={() => handleCenterStoneChange(idx)}
                                                                    style={{
                                                                            padding: '6px 14px',
                                                                            border: centerStoneSize === size ? `2px solid ${colorCode}` : '1px solid #ccc',
                                                                            borderRadius: '4px',
                                                                            background: 'white',
                                                                            color: '#333',
                                                                            cursor: 'pointer',
                                                                            fontSize: '13px',
                                                                            fontWeight: centerStoneSize === size ? 'bold' : 'normal',
                                                                        }}
                                                            >
                                                                {size} ct
                                                            </button>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <div style={{ padding: "10px 10px 20px 10px" }}>
                                                                <Slider
                                                                    min={0}
                                                                    max={STONE_SIZE_OPTIONS.length - 1}
                                                                    step={1}
                                                                    value={STONE_SIZE_OPTIONS.indexOf(centerStoneSize)}
                                                                    onChange={handleCenterStoneChange}
                                                                    marks={STONE_SIZE_MARKS}
                                                                    dotStyle={{ borderColor: colorCode }}
                                                                    activeDotStyle={{ borderColor: colorCode }}
                                                                    trackStyle={{ backgroundColor: colorCode, height: 4 }}
                                                                    handleStyle={{ borderColor: colorCode, height: 24, width: 24, marginTop: -10, backgroundColor: colorCode }}
                                                                    railStyle={{ backgroundColor: colorCode, height: 4 }}
                                                                />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 finger-size-final' style={{padding:`2px`}}>
                                        <div className='form-group'>
                                            <FingerSize fingerSize={fingerSize} onChange={handleFingerSizeChange} labelName="Finger Size"  />
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12' >
                                {centerShapeLoading ? (
                                    <SpinnerComponent />
                                ):(
                                    <div style={{ maxWidth: "750px", margin: "0 auto" }}>
                                        {centerStoneShapeList.length > 0 &&(
                                            <>
                                                <SliderImages requestOption = {centerStoneShapeList} labelName={'Center-Stone Shape'} selectedValue={centerStoneShape} onChange={(e) => handleCenterStoneShape(e.target.value, e.target.dataset.id)} textName="shape_id" />
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                {headLoading ? (
                                    <SpinnerComponent />
                                ):(
                                    <div style={{ maxWidth: "750px", margin: "0 auto" }}>
                                        {itemHeadList.length > 0 &&(
                                            <>
                                                <SliderImages requestOption = {itemHeadList} labelName={'Head'} selectedValue={headItemDetail} onChange={(e) => handleHeadItemDetail(e.target.value, e.target.dataset.id)} textName="head_name" />
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                {shangLoading ? (
                                    <SpinnerComponent />
                                ):(
                                    <div style={{ maxWidth: "750px", margin: "0 auto" }}>
                                        {itemShangList.length > 0 &&(
                                            <>
                                                <SliderImages requestOption = {itemShangList} labelName={'Shank'} selectedValue={shangItemDetail} onChange={(e) => handleShangItemDetail(e.target.value, e.target.dataset.id)} textName="shank_name" />
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            {(client_code == 'W284' && windowWidth <= 950) && (
                                <>
                                    <hr />
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                        <div className='product_details text-center' style={{marginTop:'20px',marginBottom: '6px'}}>
                                            {shahApiProduct?.product_name_sp != "" && ( <h9><b>{shahApiProduct?.product_name_sp}</b></h9> )}
                                        </div>
                                    </div>
                                    {windowWidth <= 950 ? (
                                        <>
                                            <div className='col-12' style={{padding:`0px`}}>
                                                <b>Ring</b>
                                            </div>
                                            <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-metal-final' style={{padding:`0px`}}>
                                                <div className='form-group'>
                                                    <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Ring')} selectedValue={ringType} name="ring_type" labelName={'Metal Type'} />
                                                </div>
                                            </div>
                                        </>
                                    ):(
                                        <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-metal-final' style={{padding:`0px`}}>
                                            <div className='form-group'>
                                                <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Ring')} selectedValue={ringType} name="ring_type" labelName={'Ring-Metal'} />
                                            </div>
                                        </div>
                                    )}
                                    <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-color-final' style={{padding:`0px`}}>
                                        <div className='form-group'>
                                            <label><span style={{ color: 'red' }}>*</span>{windowWidth <= 950 ? 'Metal Color' : 'Ring-Metal Color'}:</label>
                                            {renderSwatches(ringColor, (value) => handleMetalColorChange(value, 'Ring'))}
                                        </div>
                                    </div>
                                    <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 ring-diamond-final' style={{padding:`0px`}}>
                                        <div className='form-group'>
                                            <CommonFilter filterKey='diamond_quality' inputType='select' onChange={(value) => handleDiamondQuality(value,'Ring')} selectedValue={ringQuality} name="ring_quality" labelName={windowWidth <= 950 ? 'Diamond Quality' : 'Ring-Diamond Quality'} />
                                        </div>
                                    </div>
                                    {windowWidth <= 950 ? (
                                        <>
                                            <div className='col-12' style={{padding:`0px`,marginTop:`20px`}}>
                                                <b>Setting</b>
                                            </div>
                                            <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-type-final' style={{padding:`0px`}}>
                                                <div className='form-group'>
                                                    <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Setting')} selectedValue={settingType} name="setting_type" labelName={'Metal Type'} />
                                                </div>
                                            </div>
                                        </>
                                    ):(
                                                <div className='col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-type-final' style={{padding:`0px`}}>
                                                    <div className='form-group'>
                                                        <CommonFilter filterKey='metal_type' inputType='radio' onChange={(value) => handleMetalType(value, 'Setting')} selectedValue={settingType} name="setting_type" labelName={'Setting-Metal'} />
                                                    </div>
                                                </div>

                                            )}
                                            <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-color-final' style={{padding:`0px`}}>
                                                <div className='form-group'>
                                                    <label><span style={{ color: 'red' }}>*</span>{windowWidth <= 950 ? 'Metal Color' : 'Setting-Metal Color'}:</label>
                                                    {renderSwatches(settingColor, (value) => handleMetalColorChange(value, 'Setting'))}
                                                </div>
                                            </div>
                                            <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 setting-diamond-final' style={{padding:`2px`}}>
                                                <div className='form-group'>
                                                    <CommonFilter filterKey='diamond_quality' inputType='select'onChange={(value) => handleDiamondQuality(value,'Setting')} selectedValue={settingQuality} name="setting_quality" labelName={windowWidth <= 950 ? 'Diamond Quality' : 'Setting-Diamond Quality'} />
                                                </div>
                                            </div>
                                            <div className='col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 center-stone-final' style={{padding:`0px`}}>
                                                <div className='form-group'>
                                                    <div className="col-12 center-stone-selector" style={{ padding: "5px" }}>
                                                        <label className="control-label"><span style={{color:`red`}}>*</span>CENTER STONE SIZE:</label>
                                                        <span style={{fontSize:`small`}}>(Center Stone Not Included)</span>
                                                        {windowWidth <= 950 ? (
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                                                {STONE_SIZE_OPTIONS.map((size, idx) => (
                                                                    <button
                                                                        key={size}
                                                                        onClick={() => handleCenterStoneChange(idx)}
                                                                        style={{
                                                                            padding: '6px 14px',
                                                                            border: centerStoneSize === size ? `2px solid ${colorCode}` : '1px solid #ccc',
                                                                            borderRadius: '4px',
                                                                            background: 'white',
                                                                            color: '#333',
                                                                            cursor: 'pointer',
                                                                            fontSize: '13px',
                                                                            fontWeight: centerStoneSize === size ? 'bold' : 'normal',
                                                                        }}
                                                                    >
                                                                        {size} ct
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <div style={{ padding: "10px 10px 20px 10px" }}>
                                                                <Slider
                                                                    min={0}
                                                                    max={STONE_SIZE_OPTIONS.length - 1}
                                                                    step={1}
                                                                    value={STONE_SIZE_OPTIONS.indexOf(centerStoneSize)}
                                                                    onChange={handleCenterStoneChange}
                                                                    marks={STONE_SIZE_MARKS}
                                                                    dotStyle={{ borderColor: colorCode }}
                                                                    activeDotStyle={{ borderColor: colorCode }}
                                                                    trackStyle={{ backgroundColor: colorCode, height: 4 }}
                                                                    handleStyle={{ borderColor: colorCode, height: 24, width: 24, marginTop: -10, backgroundColor: colorCode }}
                                                                    railStyle={{ backgroundColor: colorCode, height: 4 }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 finger-size-final' style={{padding:`2px`}}>
                                                <div className='form-group'>
                                                    <FingerSize fingerSize={fingerSize} onChange={handleFingerSizeChange} labelName="Finger Size"  />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <hr />
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12' style={{textAlign: 'center'}}>
                                        {!loadingItemPrices ? (
                                            <>
                                                {headPrices > 0 && shangPrices > 0 ?(
                                                    <>
                                                        {diamondPriceDetails > 0 ? (
                                                            <>
                                                                <h5>MSRP: <HeadIcon />{formatNumber(headPrices)} + <ShankIcon />{formatNumber(shangPrices)} + <i className="fas fa-gem"></i> {formatNumber(diamondPriceDetails)} = {formatNumber(totalPrice)}</h5><br/>
                                                                <span>{selectedDiamondDetails?.shape} {selectedDiamondDetails?.carat}Ct | {selectedDiamondDetails?.clarity}({selectedDiamondDetails?.diamond_type}) | {selectedDiamondDetails?.Lab} | {selectedDiamondDetails?.certificate} </span>
                                                            </>
                                                        ):(
                                                            <h5>MSRP: <HeadIcon />${formatNumber(headPrices)} + <ShankIcon />${formatNumber(shangPrices)} = ${formatNumber(totalPrice)}</h5>
                                                        )}
                                                        <br/>
                                                        {itemHeadDetails?.item_no  && itemShangDetails?.item_no  && (
                                                            <><span><b>Head: {itemHeadDetails.item_no} || Shank: {itemShangDetails.item_no}</b></span><br/></>
                                                        )}
                                                        {(diamondPriceDetails == '0' || isNaN(diamondPriceDetails)) && (
                                                            <span style={{fontStyle: 'italic',fontSize: 'large'}} className=" help-block">Note: Center stone price is not included</span>
                                                        )}
                                                    </>
                                                ):(
                                                    <span style={{textAlign:`center`,fontSize:`large`,fontWeight:`bold`,padding:`10px`}}>Request for price....</span>
                                                )}
                                            </>
                                        ):(
                                            <span>Loading...</span>
                                        )}
                                    </div>
                                    {basketError && (
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12' style={{textAlign: 'center', marginBottom: '8px'}}>
                                            <span style={{color: '#c0392b', fontSize: '14px', fontWeight: '500'}}>{basketError}</span>
                                        </div>
                                    )}
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12' style={{textAlign: 'center'}}>
                                        {isReceDiamond == 'Yes' ? (
                                            <div className='row'>
                                                <div className='col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6' style={{textAlign:`center`}}>
                                                    <a  style={{background:'var(--color-theme)',borderColor:'var(--color-theme)',margin: '2px',width: '-webkit-fill-available',color:'white'}} className="schedule-appointment btn btn-primary" role="button" aria-disabled="true" onClick={() => handlePageAppointment()}><i className="fa fa-lock" aria-hidden="true"></i> Schedule Appointment</a>
                                                </div>
                                                <div className='col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6' style={{textAlign:`center`}}>
                                                    <a style={{background:'var(--color-theme)',borderColor:'var(--color-theme)',margin: '2px',width: '-webkit-fill-available',color:'white'}} className="recommended-diamonds btn btn-primary btn_load_diamond_recommend" onClick={toggleDiamondModal} role="button" aria-disabled="true"><i className="fa fa-gem" aria-hidden="true"></i> Recommended Diamonds</a> 
                                                </div>
                                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12' style={{textAlign:`center`}}>
                                                    <a href="#" onClick={handleOpenSaveWishlist} style={{textDecoration: 'none',color:'var(--color-theme)',fontSize:'small'}} aria-disabled="true"><i className="fa fa-heart"></i> Save to Wishlist</a>&nbsp;&nbsp;
                                                    <a href="#" onClick={(e) => handleAddToBasket(e)} style={{textDecoration: 'none',color:'var(--color-theme)',fontSize:'small'}} className="AddBasket" role="button" aria-disabled="true">
                                                        {isInBasket ? (
                                                            <>
                                                                <i class="fa fa-eye" aria-hidden="true"></i> Preview Basket
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="fa fa-cart-plus"></i> Add to Basket
                                                            </>
                                                        )}
                                                    </a>&nbsp;&nbsp;
                                                    <a className="drop-hit" href="#" style={{textDecoration: 'none',color:'var(--color-theme)',fontSize:'small'}} onClick={() => handleDropHitModel()} aria-disabled="true"><i className="fa fa-envelope"></i> Drop A Hint</a>
                                                </div>
                                            </div>
                                        ):(
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <a  style={{background:'var(--color-theme)',borderColor:'var(--color-theme)',margin: '2px',width: '-webkit-fill-available',color:'white'}} className="schedule-appointment btn btn-primary" role="button" aria-disabled="true" onClick={() => handlePagesChanges('AppointmentSchedule')}><i className="fa fa-lock" aria-hidden="true"></i> Schedule Appointment</a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <a href="#" onClick={handleOpenSaveWishlist} style={{textDecoration: 'none',color:'var(--color-theme)',fontSize:'small'}} aria-disabled="true"><i className="fa fa-heart"></i> Save to Wishlist</a>&nbsp;&nbsp;
                                                            <a href="#" onClick={(e) => handleAddToBasket(e)} style={{textDecoration: 'none',color:'var(--color-theme)',fontSize:'small'}} className="AddBasket" role="button" aria-disabled="true">
                                                                {isInBasket ? (
                                                                    <>
                                                                        <i class="fa fa-eye" aria-hidden="true"></i> Preview Basket
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <i className="fa fa-cart-plus"></i> Add to Basket
                                                                    </>
                                                                )}
                                                            </a>&nbsp;&nbsp;
                                                            <a className="drop-hit" href="#" style={{textDecoration: 'none',color:'var(--color-theme)',fontSize:'small'}} onClick={() => handleDropHitModel()} aria-disabled="true"><i className="fa fa-envelope"></i> Drop A Hint</a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        {loadingContent ? (
                            <SpinnerComponent />
                        ):(
                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12' style={{ textAlign: 'center',fontWeight: 'bold' }}>PRODUCT SPECIFICATION</div>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6' valign="top" style={{ paddingTop: '10px' }}>
                                    <table width="100%" className="setting_info" style={{ borderCollapse: 'collapse', fontFamily: 'Arial, sans-serif', fontSize: '14px', }} >
                                        <tbody>
                                            <tr>
                                                <td colSpan="2" style={{fontWeight: 'bold', textAlign:'center' }}>
                                                    SETTING INFORMATION
                                                </td>
                                            </tr>
                                            {shahApiProduct?.metal_type != "" && shahApiProduct?.metal_type != " " && shahApiProduct?.metal_type != undefined && (
                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                    <td style={{ padding: '4px 0' }}>Metal</td>
                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.metal_type}</td>
                                                </tr>
                                            )}
                                            {(shahApiProduct?.side_stone_weight != "" && shahApiProduct?.side_stone_weight != " " && shahApiProduct?.side_stone_weight != undefined) || (shahApiProduct?.center_stone_weight != "" && shahApiProduct?.center_stone_weight != " " && shahApiProduct?.center_stone_weight != undefined) && (
                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                    <td style={{ padding: '4px 0' }}>Total Carat</td>
                                                    <td style={{ padding: '4px 0' }}>{parseFloat(shahApiProduct?.side_stone_weight || 0)+(parseFloat(shahApiProduct?.center_stone_weight || 0))} ctw</td>
                                                </tr>
                                            )}
                                            {shahApiProduct?.product_type_sp != "" && shahApiProduct?.product_type_sp != " " && shahApiProduct?.product_type_sp != undefined ? (
                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                    <td style={{ padding: '4px 0' }}>Type</td>
                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.product_type_sp}</td>
                                                </tr>
                                            ):shahApiProduct?.generic_name != "" && shahApiProduct?.generic_name != " " && shahApiProduct?.generic_name != undefined ? (
                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                    <td style={{ padding: '4px 0' }}>Type</td>
                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.generic_name}</td>
                                                </tr>
                                            ):(
                                                <></>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6' valign="top" style={{ paddingTop: '10px' }}>
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style={{ textAlign: 'center', fontWeight: 'bold', borderBottom: '1px dotted #ccc' }}>STONE INFORMATION</div>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <table width="100%" style={{ borderCollapse: 'collapse', fontFamily: 'Arial, sans-serif', fontSize: '14px', }} >
                                                <tbody>
                                                    {shahApiProduct?.center_stone_type != "" && shahApiProduct?.center_stone_type != " " && shahApiProduct?.center_stone_type != undefined && (
                                                        <>
                                                            <tr style={{ textAlign:'left' }}>
                                                                <td colSpan="2" style={{ fontSize: 'small', fontWeight:`bold`,textAlign:'center' }}>
                                                                    CENTER STONE
                                                                </td>
                                                            </tr>
                                                            <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                                <td style={{ padding: '4px 0' }}>Type</td>
                                                                <td style={{ padding: '4px 0' }}>{shahApiProduct?.center_stone_type}</td>
                                                            </tr>
                                                            {shahApiProduct?.center_stone_shape != "" && shahApiProduct?.center_stone_shape != " " && shahApiProduct?.center_stone_shape != undefined && ( 
                                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                                    <td style={{ padding: '4px 0' }}>Shape</td>
                                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.center_stone_shape}</td>
                                                                </tr>
                                                            )}
                                                            {shahApiProduct?.center_stone_weight != "" && shahApiProduct?.center_stone_weight != " " && shahApiProduct?.center_stone_weight != undefined && ( 
                                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                                    <td style={{ padding: '4px 0' }}>Weight</td>
                                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.center_stone_weight}</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <table width="100%" style={{ borderCollapse: 'collapse', fontFamily: 'Arial, sans-serif', fontSize: '14px', }} >
                                                <tbody>
                                                    {shahApiProduct?.number_of_side_stone != "" && shahApiProduct?.number_of_side_stone != " " && shahApiProduct?.number_of_side_stone != undefined ? (
                                                        <>
                                                            <tr style={{ textAlign:'left' }}>
                                                                <td colSpan="2" style={{ fontSize: 'small',fontWeight:`bold`,textAlign:'center' }}>
                                                                    SIDE STONE
                                                                </td>
                                                            </tr>
                                                            <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                                <td style={{ padding: '4px 0' }}># of Diamonds</td>
                                                                <td style={{ padding: '4px 0' }}>{shahApiProduct?.number_of_side_stone}</td>
                                                            </tr>
                                                            {shahApiProduct?.side_stone_type != "" && shahApiProduct?.side_stone_type != " " && shahApiProduct?.side_stone_type != undefined && ( 
                                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                                    <td style={{ padding: '4px 0' }}>TYPE</td>
                                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.side_stone_type}</td>
                                                                </tr>
                                                            )}
                                                            {shahApiProduct?.side_stone_color != "" && shahApiProduct?.side_stone_color != " " && shahApiProduct?.side_stone_color != undefined && (
                                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                                    <td style={{ padding: '4px 0' }}>COLOR</td>
                                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.side_stone_color}</td>
                                                                </tr>
                                                            )}
                                                            {shahApiProduct?.side_stone_shaper != "" && shahApiProduct?.side_stone_shaper != " " && shahApiProduct?.side_stone_shaper != undefined && (
                                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                                    <td style={{ padding: '4px 0' }}>SHAPE</td>
                                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.side_stone_shaper}</td>
                                                                </tr>
                                                            )}
                                                            {shahApiProduct?.side_stone_clarity != "" && shahApiProduct?.side_stone_clarity != " " && shahApiProduct?.side_stone_clarity != undefined && (
                                                                <tr style={{ borderTop: '1px dotted #ccc', textAlign:'left' }}>
                                                                    <td style={{ padding: '4px 0' }}>CLARITY</td>
                                                                    <td style={{ padding: '4px 0' }}>{shahApiProduct?.side_stone_clarity}</td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    ):(<></>)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {windowWidth <= 950 && (
                                    <>
                                        {productInformation == "No" && (
                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12' style={{ textAlign: 'center' }}>
                                                <h6 style={{textTransform: 'uppercase', textAlign: 'justify', lineHeight: '18px',paddingTop:`15px`,fontSize: '1rem',fontWeight: 'bold'}}>
                                                    Product Knowledge
                                                </h6>
                                                <hr />
                                                <p className="prdesclaimer" style={{textAlign: 'justify',lineHeight: '18px',fontSize:'14px'}}>
                                                    We pride ourselves on the meticulous attention placed on design and the precision of the engineered components. However, due to the inherent nature of the materials used and handcrafted finish out, please understand that from time to time there may be a slight fluctuation in materials tolerance. This fluctuation is due in part to several factors which may include different fabrication and production dates of like pieces, necessary adjustments needed to accommodate slight variations in gem makes and cuts and the hand fabrication component. We guarantee our gem weights to be exact or understated. We also guarantee our metal karat weights to be precise and as noted. Product photography in print material and website may not reflect exact true color and/or scale.
                                                </p>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    {isModalDropHintOpen && (
                        <DropHint
                            toggleDropHintModal={toggleDropHintModal}
                        />
                    )}
                    {isModalSaveWishlistOpen && (
                        <SaveWishlist
                            toggleSaveWishlistModal={toggleSaveWishlistModal}
                            styleNumber={itemDetails?.product_code}
                            headKarat={ringType}
                            headColor={ringColor}
                            shankKarat={settingType}
                            shankColor={settingColor}
                            centerStoneWeight={centerStoneSize}
                            centerStoneShape={centerStoneShape}
                            headDiamondQuality={ringQuality}
                            shankDiamondQuality={settingQuality}
                            fingerSize={fingerSize}
                            modelComponents={layerparam}
                            canvasImage={wishlistCanvasImage}
                        />
                    )}
                    {isModalDiamondOpen && (
                        <AjaxDiamond
                            toggleDiamondModal={toggleDiamondModal}
                            handleSelectedDiamondDetails={handleSelectedDiamondDetails}
                            onStoneSizeChange={syncCenterStoneSizeToCarat}
                        />
                    )}
        </div>
    )
}

export default MainClass;